import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import CustomTable from "../../common/CustomTable";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchPurchaseOrderByID,
  fetchPurchaseOrders,
  selectPurchaseOrders,
  setPurchaseOrder,
  setViewing,
} from "./purchaseOrdersSlice";
import Grid from "@material-ui/core/Grid";
import { fetchClients, selectClients } from "../clients/clientsSlice";
// import {fetchOrderUserByID} from '../users/usersSlice';

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
  root: {
    display: "flex",
    flexFlow: "column",
  },
}));

export default function PurchaseOrdersContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const [purchaseorderNames, setPurchaseOrderNames] = useState([]);
  const [userIDs, setUserIDs] = useState([]);
  // const edit = props.location.pathname.includes("edit");
  const { purchaseOrder, error, loading, purchaseOrdersList } =
    useSelector(selectPurchaseOrders);
  const { clients, clientsList } = useSelector(selectClients);


  const [client, setClient] = useState("");
  const [dateBefore, setDateBefore] = useState("");
  const [dateAfter, setDateAfter] = useState("");
  const [searchTerm, setSearchTerm] = useState([]);

  const urlParams = new URLSearchParams(window.location.search);

  const invoiceParam = urlParams.get("invoice");
  const purchaseOrderParam = urlParams.get("purchaseOrder");

  useEffect(() => {
    if (invoiceParam) {
      dispatch(
        fetchPurchaseOrders({
          token: jwtToken,
          query: `invoices=${
            invoiceParam != null ? invoiceParam : ""
          }&limit=25&sort=desc`,
        })
      );
    }
  }, [invoiceParam]);

  useEffect(() => {
    if (purchaseOrderParam) {
      dispatch(
        fetchPurchaseOrderByID({
          token: jwtToken,
          purchaseOrderID: purchaseOrderParam,
          // query: `invoices=${invoiceParam != null ? invoiceParam : ""}&limit=25&sort=desc`,
        })
      );
    }
  }, [invoiceParam]);

  const headCells = [
    {
      id: "id",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "PurchaseOrder #",
      long: false,
    },
    {
      id: "clientID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Client ID",
      long: false,
    },
    {
      id: "productName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Product Name",
      long: false,
    },
    {
      id: "productSKU",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Product SKU",
      long: false,
    },
    {
      id: "supplierName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Supplier Name",
      long: false,
    },
    {
      id: "xeroDetails",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Xero PO No.",
      long: false,
      object: true,
      objectProperty: 'PurchaseOrders',
      nestedObject: true,
      nestedObjectProperty: 'PurchaseOrderNumber'
    },
    {
      id: "createdAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Order Date",
      long: false,
    },
    {
      id: "updatedAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Last Update",
      long: false,
    },
  ];



  // const handleOrdersChange = (event) => {
  //   let idsArr = [];
  //   // event.target.value.forEach((selected) => {
  //   let selectedOrder = ordersList.filter(
  //     (order) => order.orderNumber === event.target.value
  //   );
  //   selectedOrder && idsArr.push(selectedOrder[0].id);
  //   // });

  //   setOrderNames(event.target.value);
  //   setUserIDs(idsArr);
  // };

  // const handleStatusChange = (event) => {
  //   let idsArr = [];
  //   event.target.value.forEach((selected) => {
  //     let selectedStatus = statusList.filter(
  //       (status) => status.name === selected
  //     );
  //     selectedStatus[0] && idsArr.push(selectedStatus[0].id);
  //   });

  //   setStatusNames(event.target.value);
  //   setStatusIDs(idsArr);
  // };

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  //Need getFullListHere ??
  const handleChange = (event) => {
    setClient(event.target.value);
    dispatch(
      fetchPurchaseOrders({
        token: jwtToken,
        query: `clients=${event.target.value}&limit=100&sort=desc${searchTerm}`,
      })
    );
  };

  const handleEdit = (id) => {};

  const handleEditClick = (id) => {
    const selectedPurchaseOrder = purchaseOrdersList.filter(
      (purchaseOrder) => purchaseOrder.id === id
    );
    dispatch(setPurchaseOrder(selectedPurchaseOrder[0]));
    dispatch(
      fetchPurchaseOrderByID({
        purchaseOrderID: selectedPurchaseOrder[0].id,
        // clientID: selectedPurchaseOrder[0].clientID,
        token: jwtToken,
      })
    );
    // dispatch(setViewing(true));
  };


  const handleSearch = () => {
    let daterange = "";
    if (dateBefore && dateAfter) {
      daterange = `&udate=${dateAfter
        .toISOString()
        .substring(0, 10)},${dateBefore.toISOString().substring(0, 10)}`;
    } else if (dateBefore && !dateAfter) {
      daterange = `&udate=lte,${dateBefore.toISOString().substring(0, 10)}`;
    } else if (!dateBefore && dateAfter) {
      daterange = `&udate=gte,${dateAfter.toISOString().substring(0, 10)}`;
    }
    setSearchTerm([daterange])
    const searchQuery = `limit=500&sort=desc&id=${searchTerm}${daterange}`;
    // const searchQuery = `limit=500&sort=desc&id=${searchTerm}${daterange}&clients=${client}`;

    // dispatch(
    //   fetchClientOrders({
    //     token: jwtToken,
    //     clientID: client,
    //     query: searchQuery,
    //   })
    // );
    dispatch(
      fetchPurchaseOrders({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  useEffect(() => {
    handleSearch();
  }, [dateAfter, dateBefore]);

  const handleClear = () => {
    setDateAfter("");
    setDateBefore("");
    setClient("");
    dispatch(
      fetchPurchaseOrders({
        token: jwtToken,
        query: `limit=500&sort=desc`,
      })
    );
  };

  // const handleProcessPurchaseOrders = () => {
  //   if (client) {
  //     let endDate = new Date();
  //     // add a day
  //     endDate.setDate(endDate.getDate() + 1);
  //     const options = {
  //       year: "numeric",
  //       month: "2-digit",
  //       day: "2-digit",
  //     };
  //     let formattedDate = endDate
  //       .toLocaleDateString("tn-ZA", options)
  //       .split("/")
  //       .reverse()
  //       .join("-");
  //     dispatch(
  //       processOrders({
  //         token: jwtToken,
  //         clientID: client,
  //         endDate: formattedDate,
  //       })
  //     );
  //   }
  // };

  const selectNames = ["status"];

  const [rowList, setRowList] = useState([...headCells]);

  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded" || loading === "idle") {
    content = (
      <CustomTable
        data={purchaseOrdersList}
        actionsLists={[]}
        actionsHandleChange={[handleChange]}
        actionsNames={[]}
        headCells={headCells}
        cellList={cellList}
        // handleEditClick={handleEditClick}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEdit={handleEdit}
        area={"purchase-order"}
        selectNames={selectNames}
        setSearchTerm={setSearchTerm}
        setDateBefore={setDateBefore}
        setDateAfter={setDateAfter}
        dateAfter={dateAfter}
        dateBefore={dateBefore}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
      />
    );
  }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {/* <Grid
        item
        sm
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 32,
          paddingRight: 32,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              marginRight: 24,
              padding: 0,
              marginLleft: 12,
              fontSize: 24,
              fontWeight: "bold",
              color: "#42494E",
              marginBottom: 0,
              marginTop: 4,
            }}
          >
            Select Client:
          </div>

          <div>
            <FormControl
              style={{ width: 250 }}
              margin="dense"
              className={classes.formControl}
            >
              <Select
                variant="outlined"
                value={client}
                margin="dense"
                onChange={handleChange}
                inputProps={{
                  name: "client",
                  id: "client-simple",
                }}
              >
                {clientsList.map((client) => (
                  <option key={client.id} value={client.id}>
                    {client.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div onClick={handleProcessPurchaseOrders}>
          <ColorButton key={client.id} disabled={!client}>
            Process PurchaseOrders
          </ColorButton>
        </div>
      </Grid> */}

      {content}
    </Grid>
  );
}
